import { graphql } from "gql.tada";

export const AccessibleMediaFragment = graphql(`
  fragment AccessibleMediaFragment on AccessibleMedia {
    sys { id }
    altText
    caption
    transcription
    posterImage {
      contentType
      title
      url
    }
    media {
      contentType
      _id
      url
    }
  }
`);
